<!--
    描述：项目管理 --讯匠通项目- 招募基本信息
    Created by hw
-->
<template>
  <div class="juyi-project-msg-main">
    <!-- :class="[ audit === 'view'? 'expert-overflow' :'' ]" -->
    <div class="expert-content">
      <el-form
        :model="xunjiangProjectMsg"
        label-width="170px"
        size="small"
        ref="personForm"
        :show-message="false"
      >
        <el-row class="mb20">
          <el-col :span="24">
            <h3>{{ xunjiangProjectMsg.sname }}</h3>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item>
              <span slot="label">
                <span class="blacktext">当前状态：</span>
              </span>
              <div class="bluetext">{{ currentState }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募方：">
              {{ xunjiangProjectMsg.publisherName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布时间：">
              {{ xunjiangProjectMsg.sendTime }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募类型：">
              {{ xunjiangProjectMsg.recruitTypeName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募岗位：">
              {{ xunjiangProjectMsg.recruitPostionNames }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募地区：">
              {{
                xunjiangProjectMsg.projectProvinceName +
                xunjiangProjectMsg.projectCityName
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募截止时间：">
              <span class="redtext">{{ xunjiangProjectMsg.endDate }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募方联系人：">
              {{ xunjiangProjectMsg.linkMan }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式：">
              {{ xunjiangProjectMsg.linkPhone }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募对象要求：">
              {{ xunjiangProjectMsg.objectType | objectTypeFilter }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募人数：">
              <span class="bluetext">
                {{ xunjiangProjectMsg.recruitNum }}
              </span>
              人
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="招募详情：">
              <pre
                style="
                  font-size: 14px;
                  font-family: Avenir, Helvetica, Arial, sans-serif;
                  white-space: pre-wrap;
                "
                >{{ xunjiangProjectMsg.recruitDetail }}</pre
              >
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="福利待遇：">
              <el-tag
                v-for="(item, index) in xunjiangProjectMsg.welfareArr"
                class="fuliitembox"
                :key="'fuli' + index"
                >{{ item }}</el-tag
              >
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传附件资料：">
              <div class="beyondHiding">
                    <div
                        v-for="(item, index) in xunjiangProjectMsg.sysFiles"
                        :key="index"
                        class="link mr10"
                        type="text"
                        @click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
                    >
                      <span slot="reference">{{ item.fileName }}</span>
<!--                      <el-popover
                          placement="top-start"
                          title="文件"
                          trigger="hover"
                      >
                        <div
                            v-for="e in xunjiangProjectMsg.sysFiles"
                            class="link"
                            :key="e.id"
                            @click="viewFile(e.fullFilePath)"
                        >
                          {{ e.fileName }}
                        </div>
                        <span slot="reference">{{ item.fileName }}</span>
                      </el-popover>-->
                    </div>
              </div>

<!--              <my-upload
                ref="cns"
                :aid="xunjiangProjectMsg.id"
                :maxNum="1"
                :tableName="'business_expand_xunjiang'"
                mode="view"
                forDatabase="project_audit"
                :isDisabled="true"
              >
              </my-upload>-->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="岗位要求：">
              <el-table
                :data="xunjiangProjectMsg.jobDetailsArr"
                highlight-current-row
                row-key="id"
                border
                ref="table"
              >
                <el-table-column
                  prop="positonName"
                  label="招募岗位"
                  align="center"
                  header-align="center"
                  min-width="150"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="workNature"
                  label="工作性质"
                  align="center"
                  header-align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.workNature == 1 ? "全职" : "兼职"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="recruitNum"
                  label="招募人数"
                  header-align="center"
                  align="center"
                  min-width="140"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="remunerationText"
                  label="薪资待遇"
                  align="center"
                  width="110"
                  show-overflow-tooltip
                >
                </el-table-column>

                <el-table-column
                  prop="minEducationText"
                  label="学历要求"
                  align="center"
                  header-align="center"
                  min-width="120"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="ageRequireText"
                  label="年龄要求"
                  align="center"
                  header-align="center"
                  min-width="140"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="workingYearsText"
                  label="工作年限要求"
                  header-align="center"
                  min-width="140"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="qualificationText"
                  label="执业资格要求"
                  header-align="center"
                  min-width="140"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="remark"
                  label="其它"
                  header-align="center"
                  align="center"
                  min-width="140"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="pdl10 pdr10" v-if="audit === 'view'">
      <h3>审核记录：</h3>
      <el-table
        :data="checkData"
        class="mt15"
        height="200px"
        highlight-current-row
        row-key="id"
        border
        ref="table"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="70"
        ></el-table-column>
        <el-table-column
          label="审核人"
          align="center"
          width="140"
          prop="createUserName"
        ></el-table-column>
        <el-table-column
          label="审核时间"
          align="center"
          width="150"
          prop="createDate"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.createDate ? scope.row.createDate.substring(0, 16) : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作步骤"
          align="center"
          width="120"
          prop="currentSteps"
        ></el-table-column>
        <el-table-column label="审核结果" header-align="center" prop="content">
        </el-table-column>
      </el-table>
    </div>
    <div class="footer text-right">
      <el-button
        size="mini"
        icon="el-icon-edit-outline"
        v-if="audit === 'audit'"
        @click="auditSubmit"
        >审核</el-button
      >
    </div>
  </div>
</template>
<script>
import TextTooltip from "@/views/operation-management/audit-affairs-new/components/TextTooltip";
// import { mapState } from 'vuex'
import VUE_CONFIG from "../../../../../vue.config";
import {
  xunjiangselectProjectById,
  xjtOperation,
} from "api/modules/projectManagement";
export default {
  components: {
    TextTooltip,
  },
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    audit: {
      type: String,
      default: "",
    },
  },
  // filters: {
  // 	dateFilter(time) {
  // 		return bmTooljs.dateformat(new Date(time), 'yyyy-MM-dd')
  // 	},
  // },
  data() {
    return {
      currentState: "", //当前状态
      xunjiangProjectMsg: {
        id: "",
        baseId: "",
        businessId: "",
        sname: "",

        publisherName: "", //招募方
        createDate: "", //发布时间
        recruitType: "", //招募类型
        recruitTypeName: "", //招募类型
        recruitPostionNames: "", //招募岗位
        projectProvinceName: "", //省
        projectCityName: "", //市
        endDate: "", //招募截止时间
        linkMan: "", //招募方联系人
        linkPhone: "", //联系方式
        objectType: "", //招募对象要求
        recruitNum: "", //招募人数
        recruitDetail: "", //招募详情
        jobDetails: "", //岗位要求
        jobDetailsArr: [], //岗位要求
        welfare: "",
        welfareArr: [], //福利
      },
      checkData: [], //操作记录
    };
  },
  filters: {
    objectTypeFilter(status) {
      const statusMap = {
        0: "个人",
        1: "企业",
        2: "个人和企业",
      };
      return statusMap[status];
    },
  },
  created() {
    if (!this.rowData.id) {
      this.$router.push({
        name: "to-audit-proJect-list",
      });
      return;
    }
    //数据加载
    this.xunjiangselectProjectById();
    this.xjtOperation(); //当前状态
  },
  methods: {
    // 审核
    auditSubmit() {
      let params = {
        id: this.xunjiangProjectMsg.baseId,
      };
      this.$emit("openDia", params);
    },
    //获取询匠通项目
    xunjiangselectProjectById() {
      xunjiangselectProjectById({
        id: this.rowData.id,
      }).then((res) => {
        if (res.operationCode == "1") {
          this.xunjiangProjectMsg = res.data;
          this.xunjiangProjectMsg.jobDetails = JSON.parse(res.data.jobDetails);
          this.xunjiangProjectMsg.jobDetailsArr =
            this.xunjiangProjectMsg.jobDetails;
          if (this.xunjiangProjectMsg.welfare) {
            this.xunjiangProjectMsg.welfareArr =
              this.xunjiangProjectMsg.welfare.split(",");
          } else {
            this.xunjiangProjectMsg.welfareArr = [];
          }
        }
      });
    },
    //获取询匠通项目当前状态
    xjtOperation() {
      xjtOperation({
        id: this.rowData.businessId,
      }).then((res) => {
        if (res.operationCode == "1") {
          this.currentState = res.data.recruitStatusText;
        }
      });
    },
    // 查看文件
    viewFile(filePath, fileName) {
      let uploadUrl = "";
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      this.$previewFn(uploadUrl + filePath, fileName);
    },
  },
};
</script>
<style scoped lang="less">
.juyi-project-msg-main {
  height: 100%;
  .header-note {
    height: 34px;
    line-height: 34px;
    padding: 0 13px;
    border: 1px solid #fbcdd1;
    font-size: 12px;
    color: #e60012;
    background: #fde6e6;
    margin-bottom: 13px;
  }
  .expert-overflow {
    height: calc(~"100% - 210px - 20px");
    overflow-y: auto;
  }

  .expert-content {
    background-color: #fff;
    padding: 20px;
    // height: calc(~'100% - 210px - 20px');
    // overflow-y: auto;
    .numblerbox {
      padding: 20px 80px;
      display: flex;
      .numblerboxItem {
        .itembox {
          margin-bottom: 10px;
          .number {
            display: inline-table;
            border-radius: 14px;
            width: 25px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            font-size: 14px;
            vertical-align: middle;
          }
          .blue-bg {
            background-color: #199ed8;
            color: #fff;
          }
          .gray-bg {
            border: 1px solid #999;
            color: #1e1e1e;
          }
          .line {
            margin: 0 4px;
            display: inline-block;
            width: 135px;
            height: 2px;
            // margin-top: 10px;
          }
          .blue-line {
            border-top: 1px solid #199ed8;
          }
          .gray-line {
            border-top: 1px solid #999;
          }
        }
        .descbox {
          text-align: center;
          margin-left: -140px;
          .dec-text {
            font-size: 14px;
          }
          .md5 {
            margin-bottom: 5px;
          }
        }
      }
    }
  }
  .bluetext {
    color: #0000ff;
    font-weight: 600;
  }

  // .file-row {
  // 	background-color: #fafbfe;
  // 	padding: 15px 0 0;
  // 	margin-bottom: 15px;
  // }

  // .el-checkbox {
  // 	margin-right: 24px !important;
  // }

  // .btn-tools {
  // 	position: absolute;
  // 	right: 30px;
  // 	top: 10px;
  // 	z-index: 10;

  // 	.btn-icons {
  // 		display: block;
  // 		width: 40px;
  // 		line-height: 40px;
  // 		height: 40px;
  // 		text-align: center;
  // 		font-size: 20px;
  // 		color: #fff;
  // 		cursor: pointer;
  // 	}

  // 	.red-bg {
  // 		background-color: #f44336;
  // 	}

  // 	.blue-bg {
  // 		background-color: #409eff;
  // 	}
  // }

  // .menu-block {
  // 	height: 40px;
  // 	line-height: 40px;
  // 	background-color: #fafbfe;
  // 	padding: 0 20px;
  // 	font-size: 14px;
  // 	color: #202020;
  // 	margin-bottom: 10px;

  // 	.text-color {
  // 		font-size: 12px;
  // 		color: #e60012;
  // 		margin-left: 20px;
  // 	}
  // }
  .h100 {
    height: 100% !important;
  }
  .download-btn {
    vertical-align: bottom;
    margin-bottom: 18px;
    margin-left: 10px;
  }
}
.redtext {
  color: #ff0000;
}
.bluetext {
  color: #0000ff;
}
.footer {
  position: absolute;
  top: 88px;
  right: 135px;
  .el-button {
    height: 28px !important;
  }
}

.asq {
  /deep/ .el-cascader-menu__wrap {
    height: 340px;
  }
}
.fuliitembox {
  width: 90px;
  text-align: center;
  // height:20px;

  margin-right: 10px;
  margin-bottom: 10px;
}
.blacktext {
  color: #000;
  font-weight: 600;
}
</style>
